import { Component, OnInit } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { AgentInfo } from 'src/app/front-user/services/e-booking/shared/models/agent.model';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { RegistrationAdminDto } from '../../shared/models/registration-admin.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-activate-agent',
  templateUrl: './activate-agent.component.html',
  styleUrls: ['./activate-agent.component.css']
})
export class ActivateAgentComponent implements OnInit {
  lockTaskErrorMessage :boolean = false;
  activateAgent: FormGroup;
  agentId: string;
  showRequest = false;
  user: User = new User();
  adminDecisionObject: RegistrationAdminDto = new RegistrationAdminDto();
  public getAgentInfo: AgentInfo = new AgentInfo();
  formSubmitted: boolean = false;
  isErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder, private globalSrv: GlobalServices, private alertService: AlertService,
    private adminSrv: RegistrationAdminService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService, private router: Router, private route: ActivatedRoute,
    private agentSrv: AgentService) {
    this.agentId = this.route.snapshot.params.Id;

    this.user = this.authenticationService.currentUserValue;
    if (this.agentId) {

      this.agentSrv.GetAgentOnly(this.agentId).subscribe(d => {
        if (d.Success) {
          this.getAgentInfo = d.Data;
          if (this.getAgentInfo.IsOffline) {
            // this.ActivateOfflineAgent(this.agentId);
            let requestId =this.agentId
            // this.router.navigate(['/activateOfflineAgent'], { state: { data: this.agentId } });
            this.router.navigate(['/activateOfflineAgent'], { state: { data: { requestId } } });
          }
          else if (this.getAgentInfo.IsExpiredDueFees && !this.getAgentInfo.IsOffline) {
            this.adminDecisionObject.AdminEmail = this.user.UserName;
            this.adminDecisionObject.AgentId = this.agentId;
            this.adminSrv.ActivateAgentDueFees(this.adminDecisionObject).subscribe(d => {
              if (d.Success) {
                this.showRequest = true;
                this.isErrorMessage = false;
                this.lockTaskErrorMessage = false;
              }
              else if(d.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser")!=null){
                this.lockTaskErrorMessage = true;
                this.showRequest = true;
              }
              else {
                this.showRequest = true;
                this.isErrorMessage = true;
              }
            });
          }
          else if (this.getAgentInfo.IsExpiredDueCertificate && !this.getAgentInfo.IsOffline) {

            this.router.navigate(['/deactivationDate'], { state: { data: this.agentId } });


          }
        }
      });
    }else{
      window.history.back();
    }
  }

  ngOnInit() {
  }


  ActivateOfflineAgent(agentId) {
    this.adminSrv.ActivateOfflineAgent(agentId).subscribe(
      d => {
        if (d.Success) {
          this.router.navigate(['/activateOfflineAgent'], { state: { data: this.agentId } });
          //this.showRequest = true;
          //this.isErrorMessage = false;
        }
        else {
          this.showRequest = false;
          this.isErrorMessage = true;
          //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + d.ErrorMessages[0]));

        }
      }
    )
  }

}
